import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import "./brands.css";
import Common_title from "../../common-components/common-title/Common_title";
import { AllBrand } from "../../../features/master/masterSlice";

const Brands = () => {
  const dispatch = useDispatch();

  const brands = useSelector((state) => state.master.all_brands);

  useEffect(() => {
    dispatch(AllBrand());
  }, [dispatch]);

  const finalBrands = brands && brands.length > 0 ? brands : [];

  return (
    <section className="Brands_section">
      <div className="container">
        <h1 className="d-md-flex justify-content-center">
          <Common_title title={"Brands"} titleblack={"you know"} />
          <Common_title title={"Quality"} titleblack={"you trust"} />
        </h1>

      <div className="slidersec">

  {/* FIRST ROW */}
  <div className="marquee">
    <div className="marquee-content">
      {finalBrands.concat(finalBrands).map((brand, i) => (
        <div key={`row1-${i}`} className="slider_div">
          <img
            className="brandlogo"
            src={
              process.env.REACT_APP_IMAGE_URL +
              (brand.image || "/assets/images/home/brands/fallback.png")
            }
            alt={brand.name || "Brand"}
          />
        </div>
      ))}
    </div>
  </div>

  {/* SECOND ROW (reverse direction) */}
  <div className="marquee reverse mt-4">
    <div className="marquee-content">
      {finalBrands.concat(finalBrands).map((brand, i) => (
        <div key={`row2-${i}`} className="slider_div">
          <img
            className="brandlogo"
            src={
              process.env.REACT_APP_IMAGE_URL +
              (brand.image || "/assets/images/home/brands/fallback.png")
            }
            alt={brand.name || "Brand"}
          />
        </div>
      ))}
    </div>
  </div>

</div>
      </div>
    </section>
  );
};

export default Brands;
